import { Notyf } from "notyf";

// Create a singleton instance
const notyf = new Notyf({
    duration: 4000,
    position: {
        x: "right",
        y: "top",
    },
    dismissible: true,
    ripple: true,
    types: [
        {
            type: "warning",
            background: "#ffc107",
            icon: {
                className: "bi bi-exclamation-triangle",
                tagName: "i",
                text: "",
            },
        },
        {
            type: "info",
            background: "#17a2b8",
            icon: {
                className: "bi bi-info-circle",
                tagName: "i",
                text: "",
            },
        },
    ],
});

export function useNotifications() {
    const success = (message) => {
        notyf.success(message);
    };

    const error = (message) => {
        notyf.error(message);
    };

    const warning = (message) => {
        notyf.open({
            type: "warning",
            message: message,
        });
    };

    const info = (message) => {
        notyf.open({
            type: "info",
            message: message,
        });
    };

    const custom = (options) => {
        notyf.open(options);
    };

    return {
        success,
        error,
        warning,
        info,
        custom,
        notyf, // Expose the instance for advanced usage
    };
}
